export function filterFixtures(allFixtures, teamIds) {
    const fixtures = allFixtures.filter((fixture) => {
        return (
            teamIds.includes(fixture.homeTeam.team_id) ||
            teamIds.includes(fixture.awayTeam.team_id)
        )
    })
    return fixtures
}

export function findPlayer(homeTeamId, awayTeamId, proffer) {
    const players = proffer.filter((player) => {
        return player.team_id === homeTeamId || player.team_id === awayTeamId
    })
    return players
}

export function getProfferTeamIds(proffer) {
    const teamIds = proffer.map((proff) => {
        return proff.team_id
    })
    return teamIds
}
